import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BrandLogo from '@/components/BrandLogo';

/**
 * Shared dark-themed shell for static legal pages (Privacy / Terms).
 * Children can use plain prose - basic typographic styles are pre-applied.
 */
export default function LegalPageLayout({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden" data-testid={testId}>
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_#1a1033_0%,_#000000_60%)] pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-violet-600/15 rounded-full blur-[140px] pointer-events-none" />

      <header className="relative max-w-4xl mx-auto px-6 lg:px-8 pt-10 pb-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-violet-300 transition-colors" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> Back to Law Agency 360
        </Link>
        <div className="flex items-center gap-3 mt-8">
          <BrandLogo size={48} />
          <div>
            <div className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Law Agency 360</div>
            <div className="text-xs text-zinc-500">Perfect Multimedia Global Limited</div>
          </div>
        </div>
      </header>

      <main className="relative max-w-4xl mx-auto px-6 lg:px-8 pb-24">
        <h1 className="text-4xl md:text-5xl font-bold mb-3" style={{ fontFamily: 'Outfit' }}>{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-zinc-500 mb-10">Last updated: {lastUpdated}</p>
        )}
        <article className="legal-prose space-y-6 text-zinc-300 leading-relaxed">
          {children}
        </article>
      </main>

      <footer className="relative py-10 px-6 lg:px-8 border-t border-white/5 text-center text-xs text-zinc-500">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-2">
          <Link to="/privacy-policy" className="hover:text-violet-300 transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-violet-300 transition-colors">Terms &amp; Conditions</Link>
        </div>
        &copy; 2026 Law Agency 360. All rights reserved.
      </footer>
    </div>
  );
}
